import { SELECT_COMPONENTS_NAMES } from '@che-ins-ui/select';
import { DESKTOP_FONT_SIZES, DESKTOP_SIZES_BREAKPOINT, MOBILE_FONT_SIZES, } from './consts';
export const getSelectTheme = (theme) => ({
    base: {
        [SELECT_COMPONENTS_NAMES.wrapper]: {
            width: '100%',
            height: '56px',
            [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
                height: '48px',
            },
        },
        [SELECT_COMPONENTS_NAMES.groupHeader]: {
            fontSize: MOBILE_FONT_SIZES.small,
            backgroundColor: theme.colors.textBackground,
            color: theme.colors.textPrimary,
            [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
                fontSize: DESKTOP_FONT_SIZES.small,
            },
        },
        [SELECT_COMPONENTS_NAMES.listItem]: {
            fontSize: MOBILE_FONT_SIZES.main,
            height: 'auto',
            backgroundColor: theme.colors.cloud,
            color: theme.colors.sky,
            '&[data-active="true"]': {
                background: theme.colors.brandTertiary,
            },
            '&:hover': {
                [`& .che-select-${SELECT_COMPONENTS_NAMES.removeIconWrapper}`]: {
                    '& svg > path': {
                        fill: theme.colors.textPrimary,
                    },
                },
            },
            [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
                fontSize: DESKTOP_FONT_SIZES.main,
            },
        },
        [SELECT_COMPONENTS_NAMES.dropdown]: {
            overflow: 'hidden',
            backgroundColor: theme.colors.cloud,
            boxShadow: theme.elevations.dropdown,
        },
        [SELECT_COMPONENTS_NAMES.removeIconWrapper]: {
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                width: 12,
                height: 12,
                '& path': {
                    fill: theme.colors.textSecondary,
                    fillOpacity: 1,
                },
            },
        },
    },
});
